module.exports = __webpack_public_path__ + "static/jira_shot_logo.113bb323.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/jira_shot_logo.jpg
// module id = 490
// module chunks = 35783957827783